// extracted by mini-css-extract-plugin
export default {"productGrid":"Oda-z","centerLink":"Pda-z","productSection":"Qda-z","item":"Rda-z","ctaButton":"Sda-z"};